// extracted by mini-css-extract-plugin
export default {"root":"XbcySCxjdEgKtCEnap3p","bar":"AtibLc50T8O5oykJXAJR","placeHolderShimmer":"EdZSwf_OK_VCI3lX6q6v"};